/// Port of mobile/lib/game/sky/night_sky.dart.

import { Component } from '../engine/component';
import type { Rng } from '../engine/random';
import { Moon } from './moon';
import { StarManager } from './star';

/// Dark-mode sky: fixed moon + drifting stars.
export class NightSky extends Component {
  readonly moon: Moon;
  readonly stars: StarManager;

  constructor(deps: {
    allowsAmbientMotion: () => boolean;
    isPlaying: () => boolean;
    currentScore: () => number;
    rng?: Rng;
  }) {
    super(-1);
    this.moon = new Moon(deps);
    this.stars = new StarManager(deps);
    this.add(this.moon);
    this.add(this.stars);
  }

  reset(): void {
    this.moon.resetPhase();
    this.stars.reset();
  }
}
